const testimonials = [
  {
    initial: "T.M",
    age: "25歳・会社員",
    period: "6ヶ月語学留学",
    rating: 5,
    comment: "初めての海外留学で不安だらけでしたが、ClassLive留学のカウンセラーさんが学校選びから渡航準備まで全部一緒に考えてくれました。現地でトラブルがあったときもすぐに日本語で対応してもらえて、本当に心強かったです。",
    color: "bg-emerald-400",
  },
  {
    initial: "S.K",
    age: "19歳・大学生",
    period: "3ヶ月語学留学",
    rating: 5,
    comment: "正直、最初はどのエージェントも同じだと思っていました。でもClassLive留学は手数料ゼロなのにサポートが圧倒的に手厚くて驚きました。出発前のオリエンテーションも丁寧で、留学中も困ったことがあればLINEですぐ返信が来ました。",
    color: "bg-teal-400",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Testimonials</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            ✨ ClassLive留学体験者の声 ✨
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-emerald-100">
              <div className="flex items-start gap-4 mb-4">
                <div className={`w-14 h-14 flex-shrink-0 rounded-full ${t.color} flex items-center justify-center`}>
                  <span className="text-white font-bold text-sm tracking-wide">{t.initial}</span>
                </div>
                <div>
                  <div className="font-bold text-gray-800 text-sm">{t.initial}</div>
                  <div className="text-xs text-gray-500">{t.age}</div>
                  <div className="text-xs text-emerald-600 font-medium mt-0.5">{t.period}</div>
                  <div className="flex gap-0.5 mt-1">
                    {Array.from({ length: t.rating }).map((_, j) => (
                      <span key={j} className="w-3 h-3 flex items-center justify-center text-amber-400">
                        <i className="ri-star-fill text-xs" />
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">&ldquo;{t.comment}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
